module.exports = __webpack_public_path__ + "static/media/matt-aidem.4b3180e7.png";